<template>
  <v-card>
    <v-card-item class="pa-0">
      <template #title>
        <slot name="title">
          <v-list-item-title
            class="text-medium-emphasis d-flex align-center ga-3"
          >
            <div class="py-2">{{ title }}</div>
            <slot name="loading">
              <v-progress-circular
                v-if="loading"
                color="primary"
                indeterminate
                size="16"
                width="2"
              />
            </slot>
            <slot name="title-append"></slot>
          </v-list-item-title>
        </slot>
      </template>
      <template #append>
        <slot name="append"></slot>
      </template>
    </v-card-item>

    <v-card-item v-if="$slots.content" class="px-0">
      <slot name="content"></slot>
    </v-card-item>
  </v-card>
</template>
<script lang="ts" setup>
defineProps({
  title: {
    type: String,
    default: undefined,
  },
  loading: {
    type: Boolean,
    default: false,
  },
})
</script>
